"use client"

import { useState, useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { getAuth, onAuthStateChanged } from "firebase/auth"
import { getDatabase, ref as dbRef, get, set, onValue, off, push } from "firebase/database"
import { db, storage } from "../Firebase/firebase-config"
import { getStorage, ref as storageRef, uploadBytesResumable, getDownloadURL,deleteObject } from "firebase/storage"
import { useCurrentUid } from "../hooks/useCurrentUid"

// Import components
import ProductSidebar from "./ProductSidebar"
import OrderFormStep1 from "./OrderFormStep1"
import OrderFormStep2 from "./OrderFormStep2"
import OrderFormStep3 from "./OrderFormStep3"
import OrderFormStep4 from "./OrderFormStep4"
import ConfirmationModal from "./ConfirmationModal"
import SuccessModal from "./SuccessModal"
import LoadingOverlay from "./LoadingOverlay"
import ErrorNotification from "./ErrorNotification"
import AccountWarningModal from "./AccountWarningModal"

// Import CSS
import "./ProductOrderForm.css"
import { useAccount } from "../context/AccountContext"
import { MdInfo } from "react-icons/md"
import OrderInfoModal from "./OrderInfoModal"

// Constants
const MAX_FILE_SIZE_MB = 5
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024
const ALLOWED_FILE_TYPES = ["image/png", "image/jpg", "image/jpeg"]
const requiredDocuments = [
  { key: "gstCopy", label: "GST Copy", required: true },
  { key: "panCard", label: "PAN Card", required: true },
  { key: "workOrder", label: "Work Order", required: true },
  { key: "letterHead", label: "Letter Head", required: true },
  { key: "tanNumber", label: "TAN Number", required: true },
  { key: "cinCertificate", label: "CIN Certificate", required: true },
  { key: "partnershipDeed", label: "Partnership Deed", required: true },
  { key: "purchaseOrder", label: "Purchase Order (Optional)", required: false },
  { key: "cancelCheque", label: "Cancel Cheque (Optional)", required: false },
]

const ProductOrderForm = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [orderSuccess, setOrderSuccess] = useState(false);  
  const product = location.state?.product || {}
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [address, setAddress] = useState("")
  const [state, setState] = useState("")
  const [pincode, setPincode] = useState("")
  const [selectedGrade, setSelectedGrade] = useState("")
  const [selectedQuantity, setSelectedQuantity] = useState("")
  const [customQuantity, setCustomQuantity] = useState("")
  const [selectedMt, setSelectedMt] = useState("")
  const [quantities] = useState([240, 350, 480, 500, 720, 800, 1000, 1200, 2000, "Other"])
  const [mt] = useState(["25 MT", "30 MT", "35 MT", "40 MT", "45 MT"])
  const [paymentAmount, setPaymentAmount] = useState("")
  const [poFile, setPoFile] = useState(null)
  const [paymentFile, setPaymentFile] = useState(null)
  const [utrNumber, setUtrNumber] = useState("")
  const [paymentMethod, setPaymentMethod] = useState("proof")
  const [isSiteApproved, setIsSiteApproved] = useState(false);
  const [authUid, setAuthUid] = useState(null)
  const currentUserId = useCurrentUid()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [success, setSuccess] = useState(false)
  const [uploadProgress, setUploadProgress] = useState({
    po: 0,
    payment: 0,
    documents: {},
  })
  const [poUploaded, setPoUploaded] = useState(false)
  const [paymentUploaded, setPaymentUploaded] = useState(false)
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [companyName, setCompanyName] = useState("")
  const [statesList, setStatesList] = useState([])
  const [storedAddresses, setStoredAddresses] = useState([])
  const [accountDetails, setAccountDetails] = useState(null)
  const [copySuccess, setCopySuccess] = useState("")
  const [currentStep, setCurrentStep] = useState(1)
  const [formData, setFormData] = useState({})
  const [selectedSiteBalance, setSelectedSiteBalance] = useState(0)
  const [isPaymentProofRequired, setIsPaymentProofRequired] = useState(true)
  const gifUrl = "/Images/New notification.gif"
  const [showNewSiteForm, setShowNewSiteForm] = useState(false)
  const { accountSwitchTrigger } = useAccount()

  // Rate functionality state variables
  const [rateRequestSent, setRateRequestSent] = useState(false)
  const [currentRate, setCurrentRate] = useState(null)
  const [rateDate, setRateDate] = useState(null)
  const [rateRequestDetails, setRateRequestDetails] = useState(null)
  const [detailsChangedAfterRate, setDetailsChangedAfterRate] = useState(false)
  const [isNegotiating, setIsNegotiating] = useState(false)
  const [userOffer, setUserOffer] = useState("")
  const [gradeRates, setGradeRates] = useState({})
  const [rateRequestedGrades, setRateRequestedGrades] = useState({})
  const [currentSiteAddress, setCurrentSiteAddress] = useState("")
  const [isRefreshing, setIsRefreshing] = useState(false)
  const [rateLoading, setRateLoading] = useState(false)
  const [selectedCode, setSelectedCode] = useState(null)
  const [showAccountWarning, setShowAccountWarning] = useState(false)

  const [tdsTcsType, setTdsTcsType] = useState("none") // "none", "TDS", "TCS"
const [tdsTcsFile, setTdsTcsFile] = useState(null)

// Update documentFiles state to include new keys
const [documentFiles, setDocumentFiles] = useState({
  gstCopy: null,
  panCard: null,
  workOrder: null,
  letterHead: null,
  tanNumber: null,
  cinCertificate: null,
  partnershipDeed: null,
  purchaseOrder: null,
  cancelCheque: null,
})
  const [documentUploaded, setDocumentUploaded] = useState({
    gstCopy: false,
  panCard: false,
  workOrder: false,
  letterHead: false,
  tanNumber: false,
  cinCertificate: false,
  partnershipDeed: false,
  purchaseOrder: false,
  cancelCheque: false,
  })
  const [existingDocuments, setExistingDocuments] = useState({})

  useEffect(() => {
  // When currentUserId changes (account switch), reset all form state
 setAddress("")
    setState("")
    setPincode("")
    setSelectedGrade("")
    setSelectedQuantity("")
    setCustomQuantity("")
    setSelectedMt("")
    setPaymentAmount("")
    setPoFile(null)
    setPaymentFile(null)
    setUtrNumber("")
    setCurrentRate(null)
    setRateRequestSent(false)
    setRateDate(null)
    setRateRequestDetails(null)
    setDetailsChangedAfterRate(false)
    setAccountDetails(null)
    setSelectedSiteBalance(0)
    setSelectedCode(null)
    setExistingDocuments({})
   setDocumentFiles({
  gstCopy: null,
  panCard: null,
  workOrder: null,
  letterHead: null,
  tanNumber: null,
  cinCertificate: null,
  partnershipDeed: null,
  purchaseOrder: null,
  cancelCheque: null,
})
    setDocumentUploaded({
      gstCopy: false,
  panCard: false,
  workOrder: false,
  letterHead: false,
  tanNumber: false,
  cinCertificate: false,
  partnershipDeed: false,
  purchaseOrder: false,
  cancelCheque: false,
    })
    setCurrentStep(1)
    setError("")
    setSuccess(false)
    setUploadProgress({ po: 0, payment: 0, documents: {} })

    // Clear any saved draft
    localStorage.removeItem("orderFormState")
    localStorage.removeItem("documentsCompleted")
}, [currentUserId, accountSwitchTrigger])

useEffect(() => {
  return () => setOrderSuccess(false); // cleanup
}, []);

useEffect(() => {
  if (currentStep === 3 && currentUserId && product.name && address && state) {
    fetchDocuments()
  }
}, [currentStep, currentUserId, product.name, address, state, pincode])

  useEffect(() => {
    const auth = getAuth()
    const database = getDatabase()
    const connectedRef = dbRef(database, ".info/connected")

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (!user) {
        setAuthUid(null)
        setError("Session expired. Please login again.")
        setLoading(false)
        return
      }

      setAuthUid(user.uid)
      setError("")

      const unsubscribeConn = onValue(connectedRef, (snap) => {
        if (!navigator.onLine) {
          setError("You are offline. Please check your internet connection.")
          return
        }
        if (snap.val() === false) {
          setError("Could not connect to server. Please try again.")
          return
        }

       if (currentUserId) {
      fetchUserDetails(currentUserId)
      fetchStates()
      setLoading(false)
    }
  })

      return () => {
        unsubscribeConn()
      }
    })

   return () => unsubscribeAuth()
}, [currentUserId])

  useEffect(() => {
    if (!currentRate || currentRate <= 0) {
      if (selectedSiteBalance > 0) {
        setPaymentAmount("0.00")
        setIsPaymentProofRequired(false)
      } else {
        setPaymentAmount("")
        setIsPaymentProofRequired(true)
      }
      return
    }

    let totalBags = 0

    if (selectedMt) {
      const mtValue = Number.parseFloat(selectedMt.replace(" MT", "")) || 0
      totalBags = mtValue * 20
    } else if (selectedQuantity) {
      totalBags =
        selectedQuantity === "Other" ? Number.parseFloat(customQuantity) || 0 : Number.parseFloat(selectedQuantity) || 0
    }

    if (totalBags <= 0) {
      setPaymentAmount("")
      setIsPaymentProofRequired(true)
      return
    }

    const totalAmount = currentRate * totalBags

    if (selectedSiteBalance > 0) {
      if (totalAmount <= selectedSiteBalance) {
        setPaymentAmount("0.00")
        setIsPaymentProofRequired(false)
      } else {
        const remaining = totalAmount - selectedSiteBalance
        setPaymentAmount(remaining.toFixed(2))
        setIsPaymentProofRequired(true)
      }
    } else {
      setPaymentAmount(totalAmount.toFixed(2))
      setIsPaymentProofRequired(true)
    }
  }, [currentRate, selectedMt, selectedQuantity, customQuantity, selectedSiteBalance])

  const fetchUserDetails = async (currentUserId) => {
    const db = getDatabase()
    const userRef = dbRef(db, `profileDashboard/${currentUserId}`)

    try {
      const snapshot = await get(userRef)
      if (snapshot.exists()) {
        const userData = snapshot.val()
        setCompanyName(userData.company_name || "")
        if (userData.sites) {
          const addresses = Object.values(userData.sites)
          setStoredAddresses(addresses)
        }
      }
    } catch (error) {
      console.error("Error fetching user details:", error)
      setError("Failed to load user details.")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (currentUserId) {
      fetchUserCodeData()
    }
  }, [currentUserId])

  const fetchUserCodeData = async () => {
    if (!currentUserId) return

    try {
      const database = getDatabase()
      const userCodeRef = dbRef(database, `new-code/${currentUserId}/codes`)
      const snapshot = await get(userCodeRef)

      if (snapshot.exists()) {
        const codesData = snapshot.val()
        const allSites = []

        Object.entries(codesData).forEach(([codeKey, codeData]) => {
          const brand = codeData.brand || "Unknown"
          const codeID = codeData.codeID || ""
          const balance = codeData.balance || 0
          const depoAccount = codeData.depoAccount || null
          const sites = codeData.sites || {}

          Object.entries(sites).forEach(([siteId, site]) => {
            allSites.push({
              ...site,
              brand,
              code: codeKey,
              codeID,
              balance,
              siteId,
              depoAccount,
              hasDepoAccount: depoAccount !== null,
            })
          })
        })

        setStoredAddresses(allSites)
      }
    } catch (error) {
      console.error("Error fetching user code data:", error)
    }
  }

  useEffect(() => {
    if (product.name) {
      setCurrentRate(null)
      setRateDate(null)
      setRateRequestDetails(null)
      setDetailsChangedAfterRate(false)
      setRateRequestSent(false)
      setGradeRates({})
      setRateRequestedGrades({})
    }
  }, [product.name])

  useEffect(() => {
    if (product.name && currentUserId && address && state) {
      fetchDepots(product.name)
      const siteAddressKey = `${normalizeString(address)}_${normalizeString(state)}_${normalizeString(pincode)}`

      if (siteAddressKey !== currentSiteAddress) {
        setCurrentSiteAddress(siteAddressKey)
        setCurrentRate(null)
        setRateDate(null)
        setRateRequestDetails(null)
        setDetailsChangedAfterRate(false)
        setRateRequestSent(false)
      }
    }
  }, [product.name, currentUserId, address, state, pincode, selectedGrade, currentSiteAddress])

  useEffect(() => {
    if (currentUserId && product.name && address && state) {
      fetchDocuments();
    }
    
  }, [currentUserId, product.name, address, state, pincode]);

 useEffect(() => {
  setDocumentUploaded({
    gstCopy: !!existingDocuments.gstCopy || !!documentFiles.gstCopy,
    panCard: !!existingDocuments.panCard || !!documentFiles.panCard,
    workOrder: !!existingDocuments.workOrder || !!documentFiles.workOrder,
    letterHead: !!existingDocuments.letterHead || !!documentFiles.letterHead,
    tanNumber: !!existingDocuments.tanNumber || !!documentFiles.tanNumber,
    cinCertificate: !!existingDocuments.cinCertificate || !!documentFiles.cinCertificate,
    partnershipDeed: !!existingDocuments.partnershipDeed || !!documentFiles.partnershipDeed,
    purchaseOrder: !!existingDocuments.purchaseOrder || !!documentFiles.purchaseOrder,
    cancelCheque: !!existingDocuments.cancelCheque || !!documentFiles.cancelCheque,
  });
}, [existingDocuments, documentFiles]);

  useEffect(() => {
    if (currentUserId) {
      const database = getDatabase()
      const rateRef = dbRef(database, `rateRequest/${currentUserId}`)

      const unsubscribe = onValue(rateRef, (snapshot) => {
        if (snapshot.exists()) {
          const rateData = snapshot.val()
          const rateRequests = Object.entries(rateData).map(([key, value]) => ({
            id: key,
            ...value,
          }))

          const today = new Date()
          const todayRates = rateRequests.filter((request) => {
            if (!request.rate || request.brand !== product.name) return false

            const requestDate = new Date(request.rateTimestamp || request.timestamp)
            return (
              requestDate.getDate() === today.getDate() &&
              requestDate.getMonth() === today.getMonth() &&
              requestDate.getFullYear() === today.getFullYear()
            )
          })

          const newGradeRates = {}
          const newRateRequestedGrades = {}

          todayRates.forEach((request) => {
            const siteKey = `${normalizeString(request.siteAddress?.address)}_${normalizeString(request.siteAddress?.state)}_${normalizeString(request.siteAddress?.pincode)}`
            const quantityType = request.quantityType || (request.quantity.includes("MT") ? "MT" : "bags")
            const rateKey = `${request.grade}_${quantityType}`

            if (!newGradeRates[siteKey]) {
              newGradeRates[siteKey] = {}
              newRateRequestedGrades[siteKey] = {}
            }

            newGradeRates[siteKey][rateKey] = {
              rate: request.rate,
              timestamp: request.rateTimestamp || request.timestamp,
              quantity: request.quantity,
              quantityType: quantityType,
              status: request.status || "open",
              userOffer: request.userOffer || null,
            }

            newRateRequestedGrades[siteKey][rateKey] = true
          })

          setGradeRates(newGradeRates)
          setRateRequestedGrades(newRateRequestedGrades)

          if (address && state && selectedGrade && (selectedQuantity || selectedMt)) {
            const currentSiteKey = `${normalizeString(address)}_${normalizeString(state)}_${normalizeString(pincode)}`
            const quantityType = selectedMt ? "MT" : "bags"
            const rateKey = `${selectedGrade}_${quantityType}`

            if (newGradeRates[currentSiteKey] && newGradeRates[currentSiteKey][rateKey]) {
              const rateInfo = newGradeRates[currentSiteKey][rateKey]
              setCurrentRate(rateInfo.rate)
              setRateDate(rateInfo.timestamp)
              setRateRequestDetails({
                brand: product.name,
                grade: selectedGrade,
                address: address,
                state: state,
                pincode: pincode,
                quantity: rateInfo.quantity,
                quantityType: quantityType,
                status: rateInfo.status || "open",
                userOffer: rateInfo.userOffer,
              })
              setDetailsChangedAfterRate(false)
            } else {
              setCurrentRate(null)
              setRateDate(null)
              setRateRequestDetails(null)
            }
          }
        } else {
          setGradeRates({})
          setRateRequestedGrades({})
          setCurrentRate(null)
          setRateDate(null)
          setRateRequestDetails(null)
        }
      })

      return () => off(rateRef)
    }
  }, [currentUserId, product.name, address, state, pincode, selectedGrade, selectedQuantity, selectedMt])
useEffect(() => {
  if (product.name?.toLowerCase().includes("bulker")) {
    if (mt.length > 0 && !selectedMt) {
      setSelectedMt(mt[0]); // e.g. "25 MT"
    }
  }
}, [product.name, mt]);
  useEffect(() => {
    if (!currentUserId || !address || !state || !product.name) return

    const database = getDatabase()
    const codesRef = dbRef(database, `new-code/${currentUserId}/codes`)

    const unsubscribe = onValue(codesRef, (snapshot) => {
      if (snapshot.exists()) {
        const codesData = snapshot.val()
        let foundAccountDetails = null

        for (const [randomKey, codeData] of Object.entries(codesData)) {
          if (codeData.brand !== product.name) continue

          if (codeData.sites) {
            for (const site of Object.values(codeData.sites)) {
              if (site.address === address && site.state === state && (!pincode || site.pincode === pincode)) {
                if (codeData.depoAccount) {
                  foundAccountDetails = codeData.depoAccount
                  setSelectedCode(codeData.codeID)

                  setSelectedSiteBalance(codeData.balance || 0)
                  break
                }
              }
            }
          }

          if (foundAccountDetails) break
        }

        if (foundAccountDetails) {
          setAccountDetails(foundAccountDetails)
          setShowAccountWarning(false)
          setIsSiteApproved(true)
        } else {
          setAccountDetails(null)
          setIsSiteApproved(false)
        }
      }
    })

    return () => off(codesRef)
  }, [currentUserId, address, state, pincode, product.name])

  const fetchStates = () => {
    const states = [
      "Andaman and Nicobar Islands",
      "Andhra Pradesh",
      "Arunachal Pradesh",
      "Assam",
      "Bihar",
      "Chandigarh",
      "Chhattisgarh",
      "Dadra and Nagar Haveli and Daman and Diu",
      "Delhi",
      "Goa",
      "Gujarat",
      "Haryana",
      "Himachal Pradesh",
      "Jammu and Kashmir",
      "Jharkhand",
      "Karnataka",
      "Kerala",
      "Ladakh",
      "Lakshadweep",
      "Madhya Pradesh",
      "Maharashtra",
      "Manipur",
      "Meghalaya",
      "Mizoram",
      "Nagaland",
      "Odisha",
      "Puducherry",
      "Punjab",
      "Rajasthan",
      "Sikkim",
      "Tamil Nadu",
      "Telangana",
      "Tripura",
      "Uttar Pradesh",
      "Uttarakhand",
      "West Bengal",
    ]
    setStatesList(states)
  }

  const fetchDepots = async (brandName) => {
    if (!currentUserId || !address || !state) return

    const database = getDatabase()
    const codesRef = dbRef(database, `new-code/${currentUserId}/codes`)

    try {
      const snapshot = await get(codesRef)
      if (snapshot.exists()) {
        const codesData = snapshot.val()
        let foundAccountDetails = null
        let foundCode = null

        for (const [randomKey, codeData] of Object.entries(codesData)) {
          if (codeData.brand !== brandName) continue

          if (codeData.sites) {
            for (const site of Object.values(codeData.sites)) {
              if (site.address === address && site.state === state && (!pincode || site.pincode === pincode)) {
                if (codeData.depoAccount) {
                  foundAccountDetails = codeData.depoAccount
                  foundCode = codeData.codeID

                  setSelectedSiteBalance(codeData.balance || 0)
                  break
                }
              }
            }
          }

          if (foundAccountDetails) break
        }

        if (foundAccountDetails) {
          setAccountDetails(foundAccountDetails)
          setSelectedCode(foundCode)
        } else {
          setAccountDetails(null)
          setSelectedCode(null)
        }
      }
    } catch (error) {
      console.error("Error fetching depots:", error)
    }
  }

  const fetchDocuments = async () => {
    if (!currentUserId || !product.name || !address || !state) return;

    const siteKey = `${normalizeString(address)}_${normalizeString(state)}_${normalizeString(pincode || "")}`;
    const database = getDatabase();
    const docRef = dbRef(database, `userDocs/${currentUserId}/${product.name}/${siteKey}`);

    try {
      const snapshot = await get(docRef);
      if (snapshot.exists()) {
        setExistingDocuments(snapshot.val());
      } else {
        setExistingDocuments({});
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
      setExistingDocuments({});
    }
  };

  const normalizeString = (str) => {
    if (!str) return ""
    return str.toString().toLowerCase().trim().replace(/\s+/g, " ")
  }

  const handleManualRefresh = () => {
    setIsRefreshing(true)
    setTimeout(() => setIsRefreshing(false), 1000)
  }

  const validateFileSize = (file) => {
    if (!file) return false

    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      setError(`Invalid file format (${file.type}). Only PNG, JPG, JPEG are allowed.`)
      return false
    }

    if (file.size > MAX_FILE_SIZE_BYTES) {
      setError(`File size exceeds ${MAX_FILE_SIZE_MB} MB. Please upload a file under ${MAX_FILE_SIZE_MB} MB.`)
      return false
    }

    setError("")
    return true
  }

  const handlePoFileChange = (e) => {
    const file = e.target.files[0]
    if (file && validateFileSize(file)) {
      setPoFile(file)
      setPoUploaded(!!file)
    } else {
      setPoFile(null)
    }
  }

  const handlePaymentFileChange = (e) => {
    const file = e.target.files[0]
    if (file && validateFileSize(file)) {
      setPaymentFile(file)
      setPaymentUploaded(!!file)
    } else {
      setPaymentFile(null)
    }
  }

  const handleFileUpload = (file, path) => {
  return new Promise((resolve, reject) => {
    const storage = getStorage()
    const fileRef = storageRef(storage, path)
    const uploadTask = uploadBytesResumable(fileRef, file)

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        if (path.startsWith("POFiles")) {
          setUploadProgress((prev) => ({ ...prev, po: progress }))
        } else if (path.startsWith("PaymentFiles")) {
          setUploadProgress((prev) => ({ ...prev, payment: progress }))
        }
      },
      (error) => reject(error),
      () => {
        // Return PATH, not URL
        resolve(path)
      }
    )
  })
}

  const handleStep1Submit = async (e) => {
    e.preventDefault()

    if (!address.trim() || !state.trim() || !selectedGrade) {
      setError("Please fill in all required fields.")
      return
    }

    if (!(selectedQuantity || selectedMt)) {
      setError("Please select either quantity or MT.")
      return
    }

    if (selectedQuantity === "Other" && (!customQuantity || customQuantity < 240 || customQuantity > 100000)) {
      setError("Custom quantity must be between 240 and 100000.")
      return
    }

    setCurrentStep(2)
    setError("")
  }

  const handleMtChange = (e) => {
    const mtValue = e.target.value
    setSelectedMt(mtValue)
    setSelectedQuantity("")
    setCustomQuantity("")
    setDetailsChangedAfterRate(true)
  }

  const handleQuantityChange = (e) => {
    const quantity = e.target.value
    setSelectedQuantity(quantity)
    setSelectedMt("")
    if (quantity !== "Other") {
      setCustomQuantity("")
    }
    setDetailsChangedAfterRate(true)
  }

  const handleGradeSelection = (grade) => {
    setSelectedGrade(grade)
    setDetailsChangedAfterRate(true)
  }

  const handleAddressChange = (e) => {
    setAddress(e.target.value)
    setSelectedCode(null)
    setSelectedSiteBalance(0)
    setAccountDetails(null)
  }

  const handleStateChange = (e) => {
    setState(e.target.value)
    setSelectedCode(null)
    setSelectedSiteBalance(0)
    setAccountDetails(null)
  }

  const handlePincodeChange = (e) => {
    const value = e.target.value
    if (/^\d{0,6}$/.test(value)) {
      setPincode(value)
      setSelectedCode(null)
      setSelectedSiteBalance(0)
      setAccountDetails(null)
    }
  }

  const handleSiteSelection = (site) => {
    setAddress(site.address)
    setState(site.state)
    setPincode(site.pincode || "")
    setShowNewSiteForm(false)
    setSelectedCode(null)
    setSelectedSiteBalance(0)
    setAccountDetails(null)

    if (product.name) {
      fetchDepots(product.name)
    }
  }

  const handleBackToStep1 = () => {
    setCurrentStep(1)
  }

  const handleStep2Submit = (e) => {
  e.preventDefault()
  if (isSiteApproved) {
    setCurrentStep(4)  // Skip to Payment
  } else {
    setCurrentStep(3)  // Go to Documents
  }
}

 const handleSkipStep2 = () => {
  if (isSiteApproved) {
    setCurrentStep(4)
  } else {
    setCurrentStep(3)
  }
}

  const handleBackToStep2 = () => {
    setCurrentStep(2)
  }

  const deleteOldFile = async (oldPath) => {
  if (!oldPath) return
  try {
    const oldFileRef = storageRef(storage, oldPath)
    await deleteObject(oldFileRef)
    console.log("Old file deleted")
  } catch (error) {
    if (error.code !== 'storage/object-not-found') {
      console.warn("Delete failed:", error.message)
    }
  }
}
 const handleStep3Submit = async (e) => {
  e.preventDefault()

  const requiredKeys = [
    "gstCopy",
    "panCard",
    "workOrder",
    "letterHead",
    "tanNumber",
    "cinCertificate",
    "partnershipDeed"
  ]

  // 1. Check regular required documents
  const missing = requiredKeys.filter(key => 
    !documentFiles[key] && !existingDocuments[key]
  )

  if (missing.length > 0) {
    const missingLabels = missing.map(key => 
      requiredDocuments.find(doc => doc.key === key)?.label || key
    ).join(", ")
    setError(`Please upload required documents: ${missingLabels}`)
    return
  }

  // 2. TDS/TCS IS REQUIRED - Must select one
  if (tdsTcsType === "none") {
    setError("Please select TDS or TCS (Required)")
    return
  }

  // 3. Must have TDS/TCS file uploaded (new or existing)
  if (!tdsTcsFile && !existingDocuments[tdsTcsType]) {
    setError(`Please upload ${tdsTcsType} document (Required)`)
    return
  }

  // 4. Check if ANY new file is selected (including TDS/TCS)
  const hasNewRegularFiles = Object.values(documentFiles).some(file => file !== null)
  const hasNewTdsTcsFile = tdsTcsFile !== null
  const hasNewFiles = hasNewRegularFiles || hasNewTdsTcsFile

  if (!hasNewFiles) {
    // Nothing new to upload → go to next step
    setCurrentStep(4)
    return
  }

  // 5. Start upload process
  setLoading(true)
  setUploadProgress(prev => ({ ...prev, documents: {} }))

  try {
    const siteKey = `${normalizeString(address)}_${normalizeString(state)}_${normalizeString(pincode)}`
    const database = getDatabase()
    const docRef = dbRef(database, `userDocs/${currentUserId}/${product.name}/${siteKey}`)
    let newDocs = { ...existingDocuments }
    let uploadedAny = false

    // Upload regular documents
    for (const [docType, file] of Object.entries(documentFiles)) {
      if (file) {
        uploadedAny = true

        // Delete old file if replacing
        if (existingDocuments[docType]) {
          await deleteOldFile(existingDocuments[docType])
        }

        const path = await uploadDocumentWithProgress(file, docType, siteKey, (progress) => {
          setUploadProgress(prev => ({
            ...prev,
            documents: { ...prev.documents, [docType]: progress }
          }))
        })
        newDocs[docType] = path
      }
    }

    // Upload TDS/TCS (only if new file selected)
    if (tdsTcsFile) {
      uploadedAny = true

      if (existingDocuments[tdsTcsType]) {
        await deleteOldFile(existingDocuments[tdsTcsType])
      }

      const path = await uploadDocumentWithProgress(tdsTcsFile, tdsTcsType, siteKey, (progress) => {
        setUploadProgress(prev => ({
          ...prev,
          documents: { ...prev.documents, [tdsTcsType]: progress }
        }))
      })
     newDocs[tdsTcsType] = path
    }

    // Save to database
    await set(docRef, newDocs)

    if (uploadedAny) {
      await sendDocNotification()
      setSuccess("Documents uploaded successfully. We will verify and update you soon.")
    }

    // Clear form state
    setDocumentFiles({
      gstCopy: null,
      panCard: null,
      workOrder: null,
      letterHead: null,
      tanNumber: null,
      cinCertificate: null,
      partnershipDeed: null,
      purchaseOrder: null,
      cancelCheque: null,
    })
    setTdsTcsFile(null)
   

    setCurrentStep(4)
  } catch (error) {
    console.error("Upload failed:", error)
    setError("Failed to upload documents: " + error.message)
  } finally {
    setLoading(false)
    setUploadProgress(prev => ({ ...prev, documents: {} }))
  }
}

const uploadDocumentWithProgress = async (file, docType, siteKey, onProgress) => {
  const ext = file.name.split(".").pop()
  const fileName = `${docType}_${Date.now()}.${ext}`
  const path = `user-documents/${currentUserId}/${product.name}/${siteKey}/${fileName}`

  const storage = getStorage()
  const fileRef = storageRef(storage, path)
  const uploadTask = uploadBytesResumable(fileRef, file)

  return new Promise((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        onProgress(progress)
      },
      (error) => reject(error),
      async () => {
        onProgress(100)
        // Return only the PATH, not the URL
        resolve(path)
      }
    )
  })
}

  const handleSkipStep3 = () => {
    setCurrentStep(4)
  }

  const handleBackToStep3 = () => {
  if (isSiteApproved) {
    setCurrentStep(2)  // If approved, back to Rate
  } else {
    setCurrentStep(3)  // Otherwise back to Documents
  }
}

  const handleDocumentFileChange = (e, docType) => {
  const file = e.target.files[0]
  if (file && validateFileSize(file)) {
    setDocumentFiles((prev) => ({ ...prev, [docType]: file }))
    setDocumentUploaded((prev) => ({ ...prev, [docType]: true }))
    clearError?.()  // ← Clear error when they upload a missing doc
  }
}
const clearError = () => {
  setError("");
};
  const handleStep4Submit = (e) => {
    e.preventDefault()
    setShowConfirmation(true)
  }

  const handlePaymentAmountChange = (e) => {
    const value = e.target.value
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setPaymentAmount(value)
    }
  }

  const handlePaymentMethodChange = (method) => {
    setPaymentMethod(method)
    if (method === "utr") {
      setPaymentFile(null)
      setPaymentUploaded(false)
    } else {
      setUtrNumber("")
    }
  }

  const handleUtrNumberChange = (e) => {
    const value = e.target.value.replace(/[^A-Za-z0-9]/g, "")
    if (value.length <= 22) {
      setUtrNumber(value)
    }
  }

  const copyAllToClipboard = (details) => {
    const textToCopy = Object.entries(details)
      .map(([key, value]) => `${key}: ${value}`)
      .join("\n")

    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopySuccess(true)
      setTimeout(() => setCopySuccess(false), 2000)
    })
  }

  const isGetRateButtonDisabled = () => {
    if (!address.trim() || !state.trim() || !selectedGrade) return true
    if (!(selectedQuantity || selectedMt)) return true
    if (hasRequestedRateToday()) return true
    return false
  }

  const hasRequestedRateToday = () => {
    if (!address || !state || !selectedGrade || !(selectedQuantity || selectedMt)) return false

    const currentSiteKey = `${normalizeString(address)}_${normalizeString(state)}_${normalizeString(pincode)}`
    const quantityType = selectedMt ? "MT" : "bags"
    const rateKey = `${selectedGrade}_${quantityType}`

    return !!rateRequestedGrades[currentSiteKey]?.[rateKey]
  }

  const handleGetTodayRate = async () => {
    if (isGetRateButtonDisabled()) return

    setRateLoading(true)

    try {
      const database = getDatabase()
      const rateRef = dbRef(database, `rateRequest/${currentUserId}`)
      const newRateRef = push(rateRef)

      const quantityType = selectedMt ? "MT" : "bags"
      const finalQuantity = selectedMt
        ? selectedMt
        : selectedQuantity === "Other"
          ? `${customQuantity} bags`
          : `${selectedQuantity} bags`

      const rateRequest = {
        brand: product.name,
        grade: selectedGrade,
        siteAddress: {
          address,
          state,
          pincode,
        },
        quantity: finalQuantity,
        quantityType: quantityType,
        timestamp:getIndianTimestamp(),
        status: "open",
        companyName: companyName,
      }

      await set(newRateRef, rateRequest)
      setRateRequestSent(true)
      setDetailsChangedAfterRate(false)
    } catch (error) {
      console.error("Error requesting rate:", error)
      setError("Failed to request rate. Please try again.")
    } finally {
      setRateLoading(false)
    }
  }

  const handleNegotiateSubmit = async () => {
    if (!userOffer || userOffer <= 0) {
      setError("Please enter a valid offer amount.")
      return
    }

    const quantityType = selectedMt ? "MT" : "bags"
    const finalQuantity = selectedMt
      ? selectedMt
      : selectedQuantity === "Other"
        ? `${customQuantity} bags`
        : `${selectedQuantity} bags`

    try {
      const database = getDatabase()
      const rateRef = dbRef(database, `rateRequest/${currentUserId}`)
      const snapshot = await get(rateRef)

      if (snapshot.exists()) {
        const rateData = snapshot.val()

        for (const [key, request] of Object.entries(rateData)) {
          if (
            request.brand === product.name &&
            request.grade === selectedGrade &&
            normalizeString(request.siteAddress?.address) === normalizeString(address) &&
            normalizeString(request.siteAddress?.state) === normalizeString(state) &&
            request.quantity === finalQuantity &&
            request.quantityType === quantityType
          ) {
            await set(dbRef(database, `rateRequest/${currentUserId}/${key}/userOffer`), userOffer)
            await set(dbRef(database, `rateRequest/${currentUserId}/${key}/status`), "negotiating")
            break
          }
        }
      }

      setIsNegotiating(false)
      setUserOffer("")
    } catch (error) {
      console.error("Error submitting negotiation:", error)
      setError("Failed to submit offer. Please try again.")
    }
  }

  const formatDate = (timestamp) => {
    if (!timestamp) return ""
    const date = new Date(timestamp)
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  const isStep1Complete = address.trim() && state.trim() && selectedGrade && (selectedQuantity || selectedMt)

  const isStep3Complete = () => {
    return true
  }
  useEffect(() => {
  const amount = Number.parseFloat(paymentAmount) || 0

  if (amount > 0) {
    setIsPaymentProofRequired(true)
  } else {
    setIsPaymentProofRequired(false)
  }
}, [paymentAmount])

  const isStep4Complete = () => {
    if (!accountDetails) return false

    const amountValue = Number.parseFloat(paymentAmount) || 0
    if (amountValue < 5000 && selectedSiteBalance === 0) return false
    if (amountValue > 50000000) return false

    if (isPaymentProofRequired && amountValue > 0) {
      if (paymentMethod === "proof" && !paymentUploaded) return false
      if (paymentMethod === "utr" && (!utrNumber || utrNumber.length < 12)) return false
    }

    return true
  }

  const getIndianTimestamp = () => {
    const now = new Date()
    const offset = 5.5 * 60 * 60 * 1000
    const indianTime = new Date(now.getTime() + offset)
    return indianTime.toISOString().replace("Z", "+05:30")
  }

  const uploadDocument = async (file, docType, siteKey) => {
    const ext = file.name.split(".").pop();
    const path = `user-documents/${currentUserId}/${product.name}/${siteKey}/${docType}_${Date.now()}.${ext}`;
    const storage = getStorage();
    const fileRef = storageRef(storage, path);
    await uploadBytesResumable(fileRef, file);
    return await getDownloadURL(fileRef);
  };

  const sendDocNotification = async () => {
    const database = getDatabase()
    const notificationRef = dbRef(database, `supplier_notifications/Document Verification/${currentUserId}`)
    const newNotification = {
      brand: product.name,
      siteAddress: { address, state, pincode },
      companyName,
      title: "New Documents Uploaded",
      message: `New documents uploaded by ${companyName} for site ${address}, ${state}. Please verify and create code if approved.`,
      gifUrl,
      timestamp: getIndianTimestamp(),
      seen: false,
    }
    await set(push(notificationRef), newNotification)
  }

  const confirmOrder = async () => {
    setShowConfirmation(false)
    setLoading(true)

    if (paymentMethod === "proof" && isPaymentProofRequired && paymentFile && !validateFileSize(paymentFile)) {
      setLoading(false)
      return
    }

    const isValidUTR = (utr) => /^[A-Za-z0-9]{12,22}$/.test(utr)

    if (paymentMethod === "utr" && isPaymentProofRequired && !isValidUTR(utrNumber)) {
      setError("Please enter a valid UTR number (12 to 22 alphanumeric characters).")
      setLoading(false)
      return
    }

    try {
      let poFileUrl = ""
      let paymentFileUrl = ""

      if (poFile) {
  const poFilePathFull = `POFiles/${currentUserId}/${Date.now()}_${poFile.name}`
  poFileUrl = await handleFileUpload(poFile, poFilePathFull)
}

if (paymentMethod === "proof" && isPaymentProofRequired && paymentFile) {
  const paymentFilePathFull = `PaymentFiles/${currentUserId}/${Date.now()}_${paymentFile.name}`
  paymentFileUrl = await handleFileUpload(paymentFile, paymentFilePathFull)
}

      const timestamp = getIndianTimestamp()
      const paymentAmountNum = Number.parseFloat(paymentAmount) || 0

      const quantityType = selectedMt ? "MT" : "bags"

      let totalQuantity = 0
      if (selectedMt) {
        const mtNumber = Number.parseInt(selectedMt.split(" ")[0])
        if (!isNaN(mtNumber)) {
          totalQuantity = mtNumber
        }
      } else {
        totalQuantity =
          selectedQuantity === "Other" ? Number.parseInt(customQuantity) : Number.parseInt(selectedQuantity || "0")
      }

      const isUsingExistingBalance = paymentAmount === "0.00" && selectedSiteBalance > 0
      const poId = `PO_${Math.random().toString(36).substring(2, 8).toUpperCase()}`

      const orderData = {
        brand: product.name,
        grade: selectedGrade,
        siteAddress: {
          address,
          state,
          pincode,
        },
        quantity: totalQuantity,
        quantityType: quantityType,
        paymentAmount: paymentAmountNum,
        PO: poId,
        poFileUrl: poFileUrl || "",
        paymentFileUrl: paymentMethod === "proof" ? paymentFileUrl : "",
        utrNumber: paymentMethod === "utr" ? utrNumber : "",
        paymentMethod: paymentMethod,
        timestamp,
        timestampMs: Date.now(),
        status: "Pending",
        companyName,
        orderHistory: [],
        usingExistingBalance: isUsingExistingBalance,
        existingBalance: selectedSiteBalance,
        rate: currentRate || "",
        code: selectedCode || null,
      }

      const database = getDatabase()
      const userOrderRef = dbRef(database, `orders/${currentUserId}`)
      const newOrderRef = push(userOrderRef)
      await set(newOrderRef, orderData)
      const orderId = newOrderRef.key

      

      if (paymentAmountNum > 0 && selectedCode) {
        await updateSiteBalance(currentUserId, selectedCode, paymentAmountNum)
      }

      const notificationMessage = `A new cement order has been placed by ${companyName} on this site ${address}. Please review the order details.`
      const confirmationMessage = `Please confirm payment first of ${companyName} on this site ${address} for dispatches.`

      await sendNotification(currentUserId, orderId, "New Cement Order", notificationMessage)
      await PaymentNotification(currentUserId, orderId, "Payment Confirmation", confirmationMessage)

      localStorage.removeItem("orderFormState")
      localStorage.removeItem("documentsCompleted")

      setAddress("")
      setState("")
      setPincode("")
      setSelectedGrade("")
      setSelectedQuantity("")
      setCustomQuantity("")
      setSelectedMt("")
      setPaymentAmount("")
      setPoFile(null)
      setPaymentFile(null)
      setUtrNumber("")
      setPaymentMethod("proof")
      setError("")
      setSuccess(true)
      setOrderSuccess(true);
      setCurrentStep(1)
      setSelectedSiteBalance(0)
      setIsPaymentProofRequired(true)
      setRateRequestSent(false)
      setCurrentRate(null)
      setSelectedCode(null)
    } catch (error) {
      setError("Error submitting order: " + error.message)
      console.error("Error submitting order:", error)
    } finally {
      setLoading(false)
      setUploadProgress({ po: 0, payment: 0 })
    }
    
  }

  const updateSiteBalance = async (currentUserId, selectedCode, paymentAmount) => {
    if (!currentUserId || !selectedCode) return

    try {
      const database = getDatabase()
      const codeRef = dbRef(database, `new-code/${currentUserId}/codes`)
      const snapshot = await get(codeRef)

      if (snapshot.exists()) {
        const codesData = snapshot.val()

        for (const [codeKey, codeData] of Object.entries(codesData)) {
          if (codeData.codeID === selectedCode) {
            const currentBalance = codeData.balance || 0
            const newBalance = currentBalance + Number(paymentAmount)

            await set(dbRef(database, `new-code/${currentUserId}/codes/${codeKey}/balance`), newBalance)
            return
          }
        }
        console.error(`Code ${selectedCode} not found in user data`)
      } else {
        console.error("No codes exist for this user")
      }
    } catch (error) {
      console.error("Error updating code balance:", error)
    }
  }
  const sendNotification = async (currentUserId, orderId, title, message) => {
    const notificationRef = dbRef(db, `supplier_notifications/New Orders/${currentUserId}/${orderId}`)
    const newNotification = {
      brand: product.name,
      grade: selectedGrade,
      title,
      message,
      gifUrl,
      timestamp: getIndianTimestamp(),
      seen: false,
    }

    await set(notificationRef, newNotification)
  }

  const PaymentNotification = async (currentUserId, orderId, title, message) => {
    const notificationRef = dbRef(db, `supplier_notifications/Payment Confirmation/${currentUserId}/${orderId}`)
    const newNotification = {
      brand: product.name,
      grade: selectedGrade,
      title,
      message,
      gifUrl,
      timestamp: getIndianTimestamp(),
      seen: false,
    }

    await set(notificationRef, newNotification)
  }

  const cancelOrder = () => {
    setShowConfirmation(false)
  }

  const orderInfo = () => {
  alert(
    `How to Place Order - Quick Guide\n\n` +
    `Step 1: Details\n` +
    `- Enter delivery site (address, state, pincode)\n` +
    `- Select grade\n` +
    `- Choose quantity (bags: 240-2000 or MT: 25-45)\n\n` +
    `Step 2: Rate\n` +
    `- Click "Get Today's Rate" → wait for supplier approval\n` +
    `- Rate will appear once confirmed\n` +
    `- You can skip if rate already known\n\n` +
    `Step 3: Documents\n` +
    `- Upload required docs (GST, PAN, Work Order, etc.)\n` +
    `- Select & upload TDS or TCS certificate\n` +
    `- Skip if already approved for this site\n\n` +
    `Step 4: Payment\n` +
    `- View total amount (balance adjusted if available)\n` +
    `- Upload Purchase Order (PO)\n` +
    `- Pay advance → upload proof or enter UTR\n` +
    `- Review & confirm order\n\n` +
    `After submission: Supplier will verify payment & start dispatch.\n` +
    `Contact your supplier for any help.`
  );
};

  return (
    <div className="pro-det-cont">
      <h1 className="page-title">Place Your Order
       <MdInfo 
  className="icon-i" 
  style={{marginLeft:'5px', cursor: 'pointer'}} 
  onClick={() => setShowInfoModal(true)} 
/>
      </h1>
      {showInfoModal && <OrderInfoModal onClose={() => setShowInfoModal(false)} />}

      <div className="custom-step-wrapper">
        <div className={`custom-step ${currentStep >= 1 ? "active" : ""}`}>
          <div className="custom-step-circle">1</div>
          <div className="custom-step-label">Details</div>
        </div>
        <div className="custom-step-line"></div>
        <div className={`custom-step ${currentStep >= 2 ? "active" : ""}`}>
          <div className="custom-step-circle">2</div>
          <div className="custom-step-label">Rate</div>
        </div>
        <div className="custom-step-line"></div>
       <div className={`custom-step ${currentStep >= 3 || (currentStep === 4 && isSiteApproved) ? "active" : ""}`}>
  <div className="custom-step-circle">3</div>
  <div className="custom-step-label">
    Documents 
    {isSiteApproved && currentStep >= 4 && <span style={{fontSize: '0.8em', color: '#28a745'}}> (Approved ✓)</span>}
  </div>
</div>
        <div className="custom-step-line"></div>
        <div className={`custom-step ${currentStep >= 4 ? "active" : ""}`}>
          <div className="custom-step-circle">4</div>
          <div className="custom-step-label">Payment</div>
        </div>
      </div>

      <div className="product-detail-container">
        <ProductSidebar product={product} currentStep={currentStep} />

        <div className="product-content">
          {currentStep === 1 && (
            <OrderFormStep1
              handleStep1Submit={handleStep1Submit}
              address={address}
              handleAddressChange={handleAddressChange}
              storedAddresses={storedAddresses}
              product={product}
              normalizeString={normalizeString}
              state={state}
              pincode={pincode}
              setAddress={setAddress}
              setState={setState}
              setPincode={setPincode}
              setSelectedCode={setSelectedCode}
              setSelectedSiteBalance={setSelectedSiteBalance}
              setAccountDetails={setAccountDetails}
              showNewSiteForm={showNewSiteForm}
              setShowNewSiteForm={setShowNewSiteForm}
              handleSiteSelection={handleSiteSelection}
              statesList={statesList}
              handleStateChange={handleStateChange}
              handlePincodeChange={handlePincodeChange}
              selectedGrade={selectedGrade}
              handleGradeSelection={handleGradeSelection}
              selectedMt={selectedMt}
              handleMtChange={handleMtChange}
              mt={mt}
              selectedQuantity={selectedQuantity}
              handleQuantityChange={handleQuantityChange}
              quantities={quantities}
              customQuantity={customQuantity}
              setCustomQuantity={setCustomQuantity}
              isStep1Complete={isStep1Complete}
            />
          )}

          {currentStep === 2 && (
            <OrderFormStep2
              handleStep2Submit={handleStep2Submit}
              handleSkipStep2={handleSkipStep2}
              handleBackToStep1={handleBackToStep1}
              isGetRateButtonDisabled={isGetRateButtonDisabled}
              handleGetTodayRate={handleGetTodayRate}
              rateLoading={rateLoading}
              hasRequestedRateToday={hasRequestedRateToday}
              handleManualRefresh={handleManualRefresh}
              isRefreshing={isRefreshing}
              rateRequestSent={rateRequestSent}
              currentRate={currentRate}
              detailsChangedAfterRate={detailsChangedAfterRate}
              rateRequestDetails={rateRequestDetails}
              rateDate={rateDate}
              isNegotiating={isNegotiating}
              setIsNegotiating={setIsNegotiating}
              userOffer={userOffer}
              setUserOffer={setUserOffer}
              handleNegotiateSubmit={handleNegotiateSubmit}
              formatDate={formatDate}
              product={product}
            />
          )}

          {currentStep === 3 && (
  <OrderFormStep3
    handleStep3Submit={handleStep3Submit}
    handleSkipStep3={handleSkipStep3}
    handleBackToStep2={handleBackToStep2}
    documentFiles={documentFiles}
    documentUploaded={documentUploaded}
    existingDocuments={existingDocuments}
    handleDocumentFileChange={handleDocumentFileChange}
    tdsTcsType={tdsTcsType}
    setTdsTcsType={setTdsTcsType}
    tdsTcsFile={tdsTcsFile}
    setTdsTcsFile={setTdsTcsFile}
    error={error}
    clearError={clearError}
  />
)}

          {currentStep === 4 && (
            <OrderFormStep4
              handleStep4Submit={handleStep4Submit}
              handleBackToStep3={handleBackToStep3}
              selectedSiteBalance={selectedSiteBalance}
              product={product}
              paymentAmount={paymentAmount}
              handlePaymentAmountChange={handlePaymentAmountChange}
              accountDetails={accountDetails}
              copyAllToClipboard={copyAllToClipboard}
              copySuccess={copySuccess}
              setShowAccountWarning={setShowAccountWarning}
              handlePoFileChange={handlePoFileChange}
              poUploaded={poUploaded}
              paymentMethod={paymentMethod}
              handlePaymentMethodChange={handlePaymentMethodChange}
              isPaymentProofRequired={isPaymentProofRequired}
              handlePaymentFileChange={handlePaymentFileChange}
              paymentUploaded={paymentUploaded}
              utrNumber={utrNumber}
              handleUtrNumberChange={handleUtrNumberChange}
              isStep4Complete={isStep4Complete}
            />
          )}
        </div>
      </div>

      {showConfirmation && (
        <ConfirmationModal
          showConfirmation={showConfirmation}
          orderDetails={{
            brand: product.name,
            grade: selectedGrade,
            siteAddress: { address, state, pincode },
            quantity: selectedQuantity === "Other" ? customQuantity : selectedQuantity,
            mt: selectedMt,
            currentRate,
            paymentAmount,
            selectedSiteBalance,
            paymentMethod,
            utrNumber,
          }}
          onConfirm={confirmOrder}
          onCancel={cancelOrder}
        />
      )}

      {orderSuccess && <SuccessModal gifUrl={gifUrl} />}
      {loading && (
  <LoadingOverlay 
    uploadProgress={uploadProgress} 
    mode={currentStep === 3 ? "documents" : "order"} 
  />
)}
      {error && <ErrorNotification message={error} onClose={() => setError("")} />}
      {showAccountWarning && <AccountWarningModal onClose={() => setShowAccountWarning(false)} />}
    </div>
  )
}

export default ProductOrderForm